import { render, staticRenderFns } from "./IconMediaControl.vue?vue&type=template&id=54a4d01d"
import script from "./IconMediaControl.vue?vue&type=script&lang=js"
export * from "./IconMediaControl.vue?vue&type=script&lang=js"
import style0 from "./IconMediaControl.vue?vue&type=style&index=0&id=54a4d01d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports